import Head from "next/head";
import Image from "next/image";
import dynamic from "next/dynamic";
import { SITE_URL } from "@/lib/constants";

const NewHeader = dynamic(
  () => import("@/components/NewHeader").then((mod) => mod.default),
  { ssr: true }
);

const Footer = dynamic(
  () => import("@/components/homepages/Footer").then((mod) => mod.default),
  { ssr: true }
);

const articles = [
  {
    title: "Ledgerowl's seed funding fuels deeper push into Australia",
    source: "Tech in Asia",
    logo: "/logos/publications/techinasia.svg",
    href: "https://www.techinasia.com/ledgerowls-seed-funding-fuels-deeper-push-australia",
  },
  {
    title: "Ledgerowl Strategic Funding",
    source: "Skystar Capital",
    logo: "/logos/skystar-capital.svg",
    href: "https://skystar.vc/ledgerowl-strategic-funding/",
  },
  {
    title: "Init-6 and Investible inject fresh funds into Indonesian fintech firm",
    source: "Tech in Asia",
    logo: "/logos/publications/techinasia.svg",
    href: "https://www.techinasia.com/exclusive-init6-investible-inject-fresh-funds-indonesian-fintech-firm",
  },
  {
    title: "Accounting platform Ledgerowl raises funds to expand in Australia",
    source: "BackScoop",
    logo: "/logos/publications/backscoop.svg",
    href: "https://www.backscoop.com/newsletter-posts/accounting-platform-ledgerowl-raises-funds-to-expand-in-australia",
  },
  {
    title: "ID Digest: Ledgerowl, DSI",
    source: "DealStreetAsia",
    logo: "/logos/publications/dealstreetasia.svg",
    href: "https://www.dealstreetasia.com/stories/id-digest-ledgerowl-dsi-471994",
  },
];

export default function News() {
  return (
    <>
      <Head>
        <title>News & Updates | Ledgerowl AI Bookkeeping Australia</title>
        <meta
          name="description"
          content="Latest news and updates from Ledgerowl — Australia's AI-powered bookkeeping and accounting service."
        />
        <meta property="og:title" content="News & Updates | Ledgerowl AI Bookkeeping Australia" />
        <meta property="og:description" content="Latest news and updates from Ledgerowl — Australia's AI-powered bookkeeping and accounting service." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/news`} />
        <meta property="og:image" content="https://ledgerowl.com.au/favicon.png" />
        <meta property="og:site_name" content="Ledgerowl" />
        <meta property="og:locale" content="en_AU" />
        <meta
          name="keywords"
          content="AI bookkeeping news Australia, Ledgerowl updates, accounting technology Australia"
        />
        <link rel="canonical" href={`${SITE_URL}/news`} />
        <link rel="icon" href="/favicon.png" />
      </Head>

      <NewHeader />

      <section className="pt-[140px] pb-[120px] px-6 lg:px-10 bg-cream min-h-screen">
        <div className="max-w-[1340px] mx-auto">
          <h1 className="font-inter text-[36px] sm:text-[42px] lg:text-[54px] font-extrabold tracking-[-1.5px] mb-4">
            News
          </h1>
          <p className="font-inter text-[17px] text-gray-cool-500 leading-[1.8] mb-[60px] max-w-2xl">
            The latest press coverage and announcements from Ledgerowl.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {articles.map((article) => (
              <a
                key={article.href}
                href={article.href}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-base-white rounded-[20px] p-9 border border-black/[0.04] hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 flex flex-col"
              >
                <Image
                  src={article.logo}
                  alt={article.source}
                  width={120}
                  height={28}
                  className="h-[28px] w-auto object-contain object-left mb-5"
                />
                <h3 className="font-inter text-[18px] font-bold text-gray-cool-900 leading-[1.4] mb-4 flex-1">
                  {article.title}
                </h3>
                <span className="text-blue-primary-500 font-semibold text-[14px] inline-flex items-center gap-1.5">
                  Read Article
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
